import { inject, Injectable } from '@angular/core';
import { AuthService } from './auth-service';
import { CartService } from './cart-service';
import { OrderService } from './order-service';
import { Router } from '@angular/router';
import { map, Observable, take } from 'rxjs';
import { OrderType } from '../models/order';
import { collection, collectionData, doc, docData, Firestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private authService = inject(AuthService)
  private cartService = inject(CartService)
  private orderService = inject(OrderService)
  private router = Router
  private firestore = inject(Firestore);


  getServiceChargeAndDiscount(
    paymentMethod: OrderType
  ): Observable<{
    serviceCharge: number;
    serviceChargeType: 'percentage' | 'fixed';
    discount: number;
    discountType: 'percentage' | 'fixed';
  }> {

    const ref = doc(this.firestore, `payment_settings/${paymentMethod}`);

    return docData(ref).pipe(
      map((data: any) => ({
        serviceCharge: Number(data?.serviceCharge ?? 0),
        serviceChargeType: data?.serviceChargeType ?? 'percentage',
        discount: Number(data?.discount ?? 0),
        discountType: data?.discountType ?? 'percentage'
      }))
    );
  }

  getAllServiceChargeAndDiscount(): Observable<
    Record<
      string,
      {
        serviceCharge: number;
        serviceChargeType: 'percentage' | 'fixed';
        discount: number;
        discountType: 'percentage' | 'fixed';
      }
    >
  > {
    const ref = collection(this.firestore, 'payment_settings');

    return collectionData(ref, { idField: 'paymentMethod' }).pipe(
      map((data: any[]) => {
        const result: Record<string, any> = {};

        data.forEach((item) => {
          result[item.paymentMethod] = {
            serviceCharge: Number(item?.serviceCharge ?? 0),
            serviceChargeType: item?.serviceChargeType ?? 'percentage',
            discount: Number(item?.discount ?? 0),
            discountType: item?.discountType ?? 'percentage'
          };
        });

        return result;
      })
    );
  }

  // initializePayHereCheckout(cart: any, shippingDetails: any) {
  //   return new Promise((resolve, reject) => {
  //     if (!this.authService.currentUser) {
  //       reject('User not logged in');
  //       return;
  //     }

  //     const payment = {
  //       sandbox: environment.payment.payHereSandbox,
  //       merchant_id: environment.payment.merchantId,
  //       return_url: `${window.location.origin}/order-success`,
  //       cancel_url: `${window.location.origin}/cart`,
  //       notify_url: `${window.location.origin}/api/payhere/notify`,
  //       order_id: `ORD-${Date.now()}`,
  //       items: cart.items.map((item: any) => item.name).join(', '),
  //       amount: cart.total.toFixed(2),
  //       currency: 'LKR',
  //       first_name: shippingDetails.name.split(' ')[0],
  //       last_name: shippingDetails.name.split(' ').slice(1).join(' '),
  //       email: shippingDetails.email,
  //       phone: shippingDetails.phone,
  //       address: shippingDetails.address,
  //       city: shippingDetails.city,
  //       country: 'Sri Lanka',
  //       delivery_address: shippingDetails.address,
  //       delivery_city: shippingDetails.city,
  //       delivery_country: 'Sri Lanka',
  //       custom_1: this.authService.currentUser.uid,
  //       custom_2: JSON.stringify(cart.items)
  //     };

  //     PayHere.onCompleted = (orderId: string) => {
  //       console.log('Payment completed. Order ID:', orderId);
  //       this.handlePaymentSuccess(orderId, payment, shippingDetails);
  //       resolve(orderId);
  //     };

  //     PayHere.onDismissed = () => {
  //       console.log('Payment dismissed');
  //       reject('Payment dismissed by user');
  //     };

  //     PayHere.onError = (error: any) => {
  //       console.error('Payment error:', error);
  //       reject(error);
  //     };

  //     PayHere.startPayment(payment);
  //   });
  // }

  // private handlePaymentSuccess(orderId: string, payment: any, shippingDetails: any) {
  //   this.authService.user$.pipe(take(1)).subscribe(user => {
  //     if (user) {
  //       const cart = this.cartService.currentCart;
  //       if (cart) {
  //         this.orderService.createOrder(cart, {
  //           method: 'payhere',
  //           transactionId: orderId,
  //           amount: cart.total
  //         }, shippingDetails).subscribe(() => {
  //           this.cartService.clearCart().subscribe(() => {
  //             this.router.navigate(['/order-success', orderId]);
  //           });
  //         });
  //       }
  //     }
  //   });
  // }

  // verifyPayment(orderId: string) {
  //   // Implement API call to verify payment with your backend
  //   // This is just a placeholder
  //   return of({ verified: true });
  // }
}
